"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isDefined = require("b2b-components/utils/isDefined");
var _Range = require("./Range");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RangeContainer = props => {
  const {
    defaultValue,
    onChange,
    buttonLabel,
    isDisabled,
    rangesIds,
    text,
    className,
    styleType,
    dataAttributes
  } = props;
  const [stateValue, setStateValue] = (0, _react.useState)({
    min: defaultValue && defaultValue[_Range.RANGE_VALUE_TYPE.min],
    max: defaultValue && defaultValue[_Range.RANGE_VALUE_TYPE.max]
  });
  const {
    min,
    max
  } = stateValue;
  const parseValue = value => {
    if (typeof value !== 'number') {
      return undefined;
    }
    return value;
  };
  const setStateValueByType = (value, valueType) => {
    const updatedValue = {
      ...stateValue
    };
    updatedValue[valueType] = parseValue(value);
    setStateValue(updatedValue);
  };
  const handleChange = () => onChange && onChange(stateValue);
  const handleInputChange = (value, valueType) => {
    setStateValueByType((0, _isDefined.isDefined)(value) && value !== '' ? Math.abs(parseFloat(`${value}`)) : undefined, valueType);
  };
  const handleInputBlur = (value, valueType) => {
    if (value === '' || (0, _isDefined.isNotDefined)(value)) {
      return;
    }
    if (valueType === _Range.RANGE_VALUE_TYPE.min && max !== undefined && parseFloat(`${value}`) > parseFloat(`${max}`)) {
      setStateValueByType(max, valueType);
    }
    if (valueType === _Range.RANGE_VALUE_TYPE.max && min !== undefined && parseFloat(`${value}`) < parseFloat(`${min}`)) {
      setStateValueByType(min, valueType);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Range.Range, {
    buttonLabel: buttonLabel,
    className: className,
    isDisabled: isDisabled,
    rangesIds: rangesIds,
    styleType: styleType,
    text: text,
    maxValue: max !== undefined ? max : '',
    minValue: min !== undefined ? min : '',
    onChange: handleChange,
    onInputBlur: handleInputBlur,
    onInputChange: handleInputChange,
    dataAttributes: dataAttributes
  });
};
exports.RangeContainer = RangeContainer;
//# sourceMappingURL=RangeContainer.js.map